import { Link } from "react-router-dom";
import { MessageCircle, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

export const LandingHeader = () => <header data-testid="site-navbar" className="landing-header">
  <div className="landing-container flex h-full items-center justify-between gap-3">
    <Link to="/" data-testid="navbar-logo-link" className="shrink-0 rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary">
      <img src="/logo-wordmark.webp" alt="Best Escape — By NV Hospitalities" className="landing-logo" />
    </Link>
    <nav aria-label="Contact and trip planning" className="flex items-center gap-1.5 sm:gap-5 lg:gap-7">
      <a href="tel:+919816672006" data-testid="navbar-phone-link" aria-label="Call +91 98166 72006" className="landing-contact-link">
        <Phone className="h-5 w-5 text-primary" aria-hidden="true" /><span className="hidden sm:inline">+91 98166 72006</span>
      </a>
      <a href="https://wa.me/919816672006" data-testid="navbar-whatsapp-link" aria-label="Chat on WhatsApp" target="_blank" rel="noopener noreferrer" className="landing-contact-link text-primary"><MessageCircle className="h-7 w-7" aria-hidden="true" /></a>
      <Button asChild data-testid="navbar-plan-my-trip-button" className="landing-primary-button landing-header-cta">
        <a href="#plan-my-trip" onClick={(event) => {
          event.preventDefault();
          document.getElementById("plan-my-trip")?.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
          document.getElementById("itinerary-guest_name")?.focus({ preventScroll: true });
        }}>Plan My Trip</a>
      </Button>
    </nav>
  </div>
</header>;
